module.exports = __webpack_public_path__ + "static/media/5ea45bd6.jpg";